import { render, staticRenderFns } from "./TaxonomiaView.vue?vue&type=template&id=57bd9ff9&scoped=true"
import script from "./TaxonomiaView.vue?vue&type=script&lang=js"
export * from "./TaxonomiaView.vue?vue&type=script&lang=js"
import style0 from "./TaxonomiaView.vue?vue&type=style&index=0&id=57bd9ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd9ff9",
  null
  
)

export default component.exports